import { Id, PolicyAntiFraud } from 'src/types'

export const initialValues = {} as PolicyAntiFraud

export function getDefaultValues(id: Id): PolicyAntiFraud {
  const organization_id = +id === 0 ? '' : `${id}`

  return {
    active: true,
    description: '',
    organization_id,
    organization: {
      trade_name: ''
    },
    policy_request_receipt_antifraud_id: 'new',
    policy_rule_id: '',
    policy_rule: {
      name: ''
    },
    quantity: 0,
    value: 0,
    vat: false
  } as PolicyAntiFraud
}
